export default class UpdateCounterError extends Error {

}
